import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Education from './components/Education';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Certifications from './components/Certifications';
import NotebookViewer from './components/NotebookViewer';
import LoanTracker from './components/LoanTracker';
import ApproveAccess from './components/ApproveAccess';
import MemoBuilder from './components/MemoBuilder';
import styles from './App.module.css';

function getNotebookSrc(): string | null {
  const hash = window.location.hash; // e.g. #notebook=numpy_pd_neural_network.html
  const match = hash.match(/^#notebook=(.+)$/);
  return match ? `/notebooks/${match[1]}` : null;
}

const App: React.FC = () => {
  const [notebookSrc, setNotebookSrc] = useState<string | null>(getNotebookSrc);

  useEffect(() => {
    const onHashChange = () => setNotebookSrc(getNotebookSrc());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const handleClose = () => {
    window.location.hash = '';
    setNotebookSrc(null);
  };

  if (window.location.pathname === '/loan-tracker') {
    return <LoanTracker />;
  }

  if (window.location.pathname === '/approve-access') {
    return <ApproveAccess />;
  }

  if (window.location.pathname === '/memo-builder') {
    return <MemoBuilder />;
  }

  if (notebookSrc) {
    return (
      <div className={styles.app}>
        <Navbar alwaysScrolled />
        <NotebookViewer src={notebookSrc} onClose={handleClose} />
      </div>
    );
  }

  return (
    <div className={styles.app}>
      <Navbar />
      <main>
        <Hero />
        <Experience />
        <Education />
        <Skills />
        <Certifications />
        <Projects />
      </main>
      <footer className={styles.footer}>
        <p>Generated {process.env.REACT_APP_BUILD_DATE ?? 'dev'}</p>
      </footer>
    </div>
  );
};

export default App;
